<template>
	<div class="image-list flex-start flex-center flex-wrap">
		<div class="image-item" v-for="(value, key) in list" :key="key" :class="value.type =='video'?'image-video':''">
			<!-- 视频：点击弹窗播放 -->
			<div v-if="value.url.indexOf('.mp4') > -1" class="video-thumb" @click="previewVideo(value.url)">
				<i class="el-icon-video-play"></i>
			</div>
			<!-- 图片：点击放大预览 -->
			<el-image v-else :src="value.url" :preview-src-list="imageList" class="image-show" fit="cover" />
		</div>

		<!-- 视频预览弹窗 -->
		<el-dialog title="视频预览" :visible.sync="videoPreviewOpen" width="70%" append-to-body destroy-on-close>
			<video v-if="videoPreviewUrl" :src="videoPreviewUrl" controls autoplay style="width: 100%; max-height: 70vh; display: block; margin: 0 auto;" />
		</el-dialog>
	</div>
</template>

<script>
	export default {
		name:"showBoth",
		props:{
			list:{
				type: Array,
				required: false,
				default: []
			}
		},
		data() {
			return {
				videoPreviewOpen: false,
				videoPreviewUrl: ""
			}
		},
		computed: {
			imageList() {
				return this.list
					.filter(item => item.url && item.url.indexOf('.mp4') === -1)
					.map(item => item.url);
			}
		},
		methods:{
			previewVideo(url) {
				this.videoPreviewUrl = url;
				this.videoPreviewOpen = true;
			}
		}
	}
</script>

<style scoped lang="scss">
.image-list{
	width: 100%;
	.image-item{
		position: relative;
		margin: 20px 20px 20px 0px;
		.image-show{
			width: 186px;
			height: 186px;
			border-radius: 16px;
		}
		.video-thumb{
			width: 186px;
			height: 186px;
			border-radius: 16px;
			background: #000;
			display: flex;
			align-items: center;
			justify-content: center;
			cursor: pointer;
			i{
				font-size: 50px;
				color: #fff;
			}
		}
	}
}
.image-item:nth-child(3n+3){
	margin-right: 0px;
}
</style>
